// extracted by mini-css-extract-plugin
export default {"notice":"tbd-siderbar_notice__NYtrp","total":"tbd-siderbar_total__a-x+C"};